<template>
  <BannerWithBreadcrumbs2 :breadcrumbs='breadcrumbs'>
    <template #left-banner>
      <template v-if='!isFreeCancellationPage && checkGlobalGallery && apiLoaded'>
        {{galleryInfor?.name}} <template v-if='pageLevel === 0'>Tours</template>
      </template>
      <template v-if='!checkGlobalGallery'>Explore Our Gallery <span class='ttn'>of</span> Custom Tours</template>
      <template v-if='isFreeCancellationPage'>Free Cancellation Trips</template>
    </template>
    <template v-if="readmore && (!isFreeCancellationPage && checkGlobalGallery && apiLoaded)">
      <div class='mb-12 fs-14 lh-20 des mt-12 fw-400' id="read-more" v-show='!isShowDes' v-html='readmore'></div>
      <div class="fs-14 lh-20 fw-700 mt-12">
        <div @click="toggle" class='hand gray-dark dib'>
            <span v-if='isShowDes' h="view-gallery-description">
              Read more
              <img class='ml-8' src="https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-down.svg" alt="">
            </span>
          <span v-if='!isShowDes'>
              Read less
              <img class='ml-8' src="https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-up.svg" alt="">
            </span>
        </div>
      </div>
    </template>
  </BannerWithBreadcrumbs2>
</template>

<script>

import { computed, inject, ref, watch } from 'vue'
// import BannerWithBreadcrumbs from '../../../components/ui/banners/BannerWithBreadcrumbs'
import { useRoute } from 'vue-router'
import BannerWithBreadcrumbs2 from '~/components/ui/banners/BannerWithBreadcrumbs2'
import { useGalleryStore } from '~/store/pinia/gallery'

export default {
  name: "GalleryBanner",
  components: { BannerWithBreadcrumbs2/*, BannerWithBreadcrumbs*/},
  props: {
    breadcrumbs: {type: Array, default: null},
    checkGlobalGallery: {type: Boolean, default: false},
    pageLevel: {type: Number, default: 0},
    readmore: {type: String}
  },
  setup() {
    const route = useRoute()
    const isShowDes = ref(true)
    const toggle = () => {
      isShowDes.value = !isShowDes.value
    }
    const galleryStore = useGalleryStore()

    const galleryInfor = computed(() => galleryStore.galleryInfor)

    const apiLoaded = inject('pageLoaded', false)

    const isFreeCancellationPage = computed(() => {
      return route.name === "free-cancellation-trips" ? true : false
    })

    watch(route, () => {
      isShowDes.value = true
    }, {flush: 'pre', immediate: true, deep: true})

    return {
      isShowDes,
      toggle,
      galleryInfor, apiLoaded, isFreeCancellationPage
    }
  },
}
</script>

<style lang="scss" >
.breadcrumbs li:first-child { padding-left: 0; }
.breadcrumbs li:after {
  content: ''; display: inline-block; width: 8px; height: 8px; margin-left: 4px; margin-right: 6px;
  background-image: url('https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-next.svg');
  background-position: right center;
  background-size: contain;
  background-repeat: no-repeat;
}

.breadcrumbs li:last-child { padding-right: 0;}
.breadcrumbs li:last-child:after{ display:none;}

#read-more h2 { margin-bottom: 10px; }
#read-more h3 {
  margin-bottom: 10px;
  font-size: 16px;
}

#read-more p { font-size: 16px; }
#read-more a {
  text-decoration: underline!important;
  color: black!important;
}
</style>
